import { render, staticRenderFns } from "./ContractLocale.vue?vue&type=template&id=581b0300&"
import script from "./ContractLocale.vue?vue&type=script&lang=js&"
export * from "./ContractLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/ContractLocale.vue
// module id = null
// module chunks = 